import styled from 'styled-components';

const FormLabel = styled.label`
  padding: 10px 20px;
  width: 180px;
  text-align: right;
`;

export default FormLabel;

